import { Button, Grid, IconButton, makeStyles } from '@material-ui/core';
import { CheckBoxOutlineBlank, Delete, RadioButtonUncheckedOutlined } from '@material-ui/icons';
import React from 'react';

const useStyles = makeStyles(() => ({
  questionContainer: {
    height: '550px',
    width: '100%',
    background: '#f3f4f7',
  },
  questionTypeContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  questionTypeLabel: {
    padding: '5px',
    color: 'white',
    background: '#622FEE',
    borderRadius: '4px',
  },
  selectContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '15px',
  },
  select: {
    padding: '5px',
    marginLeft: '5px',
  },
  questions: {
    width: '98%',
    height: '550px',
    overflowY: 'auto',
    paddingLeft: '10px',
    paddingRight: '10px',
  },
  questionBox: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginTop: '12px',
  },
  questionInputField: {
    padding: '15px 10px',
    background: '#FEFEFE',
    borderRadius: '4px',
    border: 'none',
  },
  optionsList: {
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    paddingLeft: '10px',
  },
  openListItemLable: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
    alignItems: 'center',
  },
  optionText: {
    padding: '10px',
    borderRadius: '4px',
    background: '#fefefe',
    width: '80%',
    border: 'none',
  },
  addOption: {
    color: '#622FEE',
    cursor: 'pointer',
    width: 'fit-content',
    height: 'fit-content',
    marginTop: '-10px',
  },
  scale: {
    marginTop: '10px',
  },
  linearScaleOptions: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '10px',
    justifyContent: 'space-around',
  },
  linearScaleOption: {
    padding: '10px',
    borderRadius: '4px',
    background: '#fefefe',
    width: '40%',
    border: 'none',
  },

  addQuestionBtn: {
    padding: '5px',
    border: '2px solid #622FEE',
    height: '40px',
  },
  line: {
    width: '350px',
    height: '1px',
    background: 'grey',
  },
}));

function Checkin(props) {
  const classes = useStyles();

  return (
    <Grid className={classes.questionContainer}>
      {props.questions && (
        <Grid className={classes.questions}>
          {props.questions.map((que, questionIndex) =>
            que.deleted ? null : (
              <Grid style={{ marginTop: '10px' }} key={que.id}>
                <Grid className={classes.questionTypeContainer}>
                  <Grid className={classes.questionTypeLabel}>
                    Question: {props.getQuestionNumber(questionIndex, props.questions)}
                  </Grid>
                  <Grid>
                    <Grid className={classes.selectContainer}>
                      <Grid item>
                        Question type:
                        <select
                          className={classes.select}
                          onChange={(e) => props.onChangeQuestionType(e, questionIndex, props.questions)}
                          value={que.type}
                        >
                          <option value="radio">Single Select MCQ</option>
                          <option value="checkbox">Multiple Select MCQ</option>
                          <option value="slider">Linear Scale</option>
                        </select>
                      </Grid>
                      <Grid item>
                        <Grid item>
                          {props.questions.filter((el) => !el.deleted).length > 1 ? (
                            <IconButton onClick={() => props.onDeleteQuestion(questionIndex, props.questions)}>
                              <Delete style={{ color: '#D92D20' }} />
                            </IconButton>
                          ) : null}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                {que.type !== 'slider' ? (
                  <Grid item className={classes.questionBox}>
                    <input
                      placeholder="Write question here"
                      className={classes.questionInputField}
                      onChange={(e) => props.onChangeQuestionText(e, questionIndex, props.questions)}
                      value={que.text}
                    />

                    <ul className={classes.optionsList}>
                      {que.options.list.map((opt, optionIndex) => (
                        <li className={classes.optionListItem} key={opt.id}>
                          <label
                            htmlFor={`option_${questionIndex}_${optionIndex}`}
                            className={classes.openListItemLable}
                          >
                            {que.type === 'radio' ? <RadioButtonUncheckedOutlined /> : <CheckBoxOutlineBlank />}
                            <input
                              className={classes.optionText}
                              onChange={(e) => props.onChangeOptionText(e, questionIndex, optionIndex, props.questions)}
                              placeholder="Option"
                              value={opt.text}
                            />

                            {props.responseQuestionIds[que.id] &&
                            props.responseQuestionIds[que.id].includes(opt.id) ? null : (
                              <IconButton
                                onClick={() => props.onDeleteOption(que.id, props.questions, opt.id, questionIndex)}
                              >
                                <Delete style={{ color: '#D92D20' }} />
                              </IconButton>
                            )}
                          </label>
                        </li>
                      ))}
                    </ul>
                    <Button
                      className={classes.addOption}
                      onClick={() => props.handleAddOption(questionIndex, props.questions)}
                    >
                      + Add option
                    </Button>
                  </Grid>
                ) : (
                  <Grid item className={classes.questionBox} key={que.id}>
                    <input
                      placeholder="Write question here"
                      className={classes.questionInputField}
                      onChange={(e) => props.onChangeQuestionText(e, questionIndex, props.questions)}
                      value={que.text}
                    />
                    <Grid item className={classes.scale}>
                      Select Scale:
                      <select
                        className={classes.select}
                        onChange={(e) =>
                          props.onChangeLinearScaleValue(
                            parseInt(e.target.value, 10),
                            questionIndex,
                            'min',
                            props.questions,
                          )
                        }
                        value={que.options.min}
                      >
                        <option value="1">1</option>
                      </select>
                      to
                      <select
                        className={classes.select}
                        onChange={(e) =>
                          props.onChangeLinearScaleValue(
                            parseInt(e.target.value, 10),
                            questionIndex,
                            'max',
                            props.questions,
                          )
                        }
                        value={que.options.max}
                      >
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                      </select>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            ),
          )}
          <Grid container justifyContent="space-around" alignItems="center" style={{ marginTop: '5px' }}>
            <div className={classes.line} />
            <Button
              onClick={() => props.handleAddQuestion(props.questions)}
              color="primary"
              className={classes.addQuestionBtn}
            >
              + Add Question
            </Button>
            <div className={classes.line} />
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}

export default Checkin;
